/* @sravni/react-header version 0.2.43 */
import { __assign } from 'tslib';
import { useAnalytics } from '@sravni/react-utils';
import React__default from 'react';

var EVENTS;
(function (EVENTS) {
    EVENTS["LOGIN"] = "login";
    EVENTS["LOGOUT"] = "logout";
    EVENTS["MENU_LINK_CLICK"] = "menuLinkClick";
    EVENTS["PROMO_BANNER_CLICK"] = "promoBannerClick";
    EVENTS["PROMO_LINK_IN_VIEW"] = "promoLinkInView";
    EVENTS["TOP_MENU_SHOW"] = "topMenuShow";
    EVENTS["USER_MENU_SHOW"] = "userMenuShow";
    EVENTS["MOBILE_BURGER_CLICK"] = "mobileBurgerClick";
    EVENTS["REGION_DIALOG_CLICK"] = "regionDialogClick";
    EVENTS["THEME_SWITCHER_CLICK"] = "themeSwitcherClick";
    EVENTS["THEME_DETECTOR_CHANGE"] = "themeDetectorChange";
    EVENTS["DOWNLOAD_APP"] = "downloadApp";
})(EVENTS || (EVENTS = {}));
/**
 * React hook is a wrapper under useAnalytics hook
 * @returns pushAnalyticEvent callback to send GA events
 */
var useAnalyticEvents = function () {
    var pushEvent = useAnalytics().pushEvent;
    var pushAnalyticEvent = React__default.useCallback(function (event, options) {
        var eventAction = (options === null || options === void 0 ? void 0 : options.eventAction) || '';
        var eventLabel = (options === null || options === void 0 ? void 0 : options.eventLabel) || '';
        var eventCategory = (options === null || options === void 0 ? void 0 : options.eventCategory) || '';
        var defaultEventProperties = {
            event: 'mainEvent',
            eventCategory: 'Меню'
        };
        switch (event) {
            case EVENTS.LOGIN:
                eventAction = 'Профиль';
                eventLabel = 'Войти';
                break;
            case EVENTS.LOGOUT:
                eventAction = 'Профиль';
                eventLabel = 'Выйти';
                break;
            case EVENTS.MENU_LINK_CLICK:
                eventAction = 'Переход из меню';
                break;
            case EVENTS.PROMO_BANNER_CLICK:
                eventAction = 'Переход из меню|Кнопка партнера';
                break;
            case EVENTS.PROMO_LINK_IN_VIEW:
                eventAction = 'Показ кнопки партнера';
                break;
            case EVENTS.TOP_MENU_SHOW:
            case EVENTS.USER_MENU_SHOW:
                eventAction = 'Показ раздела';
                break;
            case EVENTS.MOBILE_BURGER_CLICK:
                eventAction = 'Бургер';
                break;
            case EVENTS.REGION_DIALOG_CLICK:
                eventAction = 'Выбор города';
                break;
            case EVENTS.THEME_SWITCHER_CLICK:
                eventAction = 'Активация|Переключение';
                eventCategory = 'Тема';
                break;
            case EVENTS.THEME_DETECTOR_CHANGE:
                eventAction = 'Активация|Автоопределение';
                eventCategory = 'Тема';
                break;
            case EVENTS.DOWNLOAD_APP: {
                eventCategory = 'Меню профиля';
                break;
            }
        }
        pushEvent(__assign(__assign(__assign({}, defaultEventProperties), { eventAction: eventAction, eventLabel: eventLabel }), (eventCategory.length > 0 ? { eventCategory: eventCategory } : {})));
    }, [pushEvent]);
    return { pushAnalyticEvent: pushAnalyticEvent };
};

export { EVENTS, useAnalyticEvents };
//# sourceMappingURL=useAnalyticEvents.js.map
